import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import SharedHeader from '../components/layout/SharedHeader';

const PaymentHistory = () => {
  const { user } = useAuth();
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPaymentHistory = async () => {
      if (!user || !user.uid) {
        setPayments([]);
        setLoading(false);
        return;
      }

      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/payment-history?userId=${user.uid}`);
        const data = await response.json();

        setPayments(Array.isArray(data.payments) ? data.payments : []);
      } catch (error) {
        console.error('Error fetching payment history:', error);
        setPayments([]);
      } finally {
        setLoading(false);
      }
    };

    fetchPaymentHistory();
  }, [user]);

  if (loading) {
    return (
      <div className="min-h-screen bg-neutral-white">
        <SharedHeader />
        <div className="flex justify-center items-center min-h-screen">
          <p className="text-gray-500">Loading...</p>
        </div>
      </div>
    );
  }

  if (!payments.length) {
    return (
      <div className="min-h-screen bg-neutral-white">
        <SharedHeader />
        <div className="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
          <div className="bg-white shadow rounded-lg">
            <div className="px-6 py-6">
              <h2 className="text-lg font-medium text-gray-900">Payment History</h2>
              <p className="mt-4 text-sm text-gray-500">No payment history available.</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-neutral-white">
      <SharedHeader />
      <div className="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
        <div className="bg-white shadow rounded-lg">
          <div className="px-6 py-6">
            <h2 className="text-lg font-medium text-gray-900">Payment History</h2>
            <ul className="divide-y divide-gray-200 mt-4">
              {payments.map((payment) => (
                <li key={payment.id} className="px-4 py-4 sm:px-6">
                  <div className="flex items-center justify-between">
                    <div className="text-sm font-medium text-blue-600">
                      {payment.description}
                    </div>
                    <div className="ml-2 flex-shrink-0 flex">
                      <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
                        {payment.status}
                      </span>
                    </div>
                  </div>
                  <div className="mt-2 sm:flex sm:justify-between">
                    <div className="sm:flex">
                      <p className="flex items-center text-sm text-gray-500">
                        ${payment.amount / 100}
                      </p>
                    </div>
                    <div className="mt-2 flex items-center text-sm text-gray-500 sm:mt-0">
                      <p>
                        {new Date(payment.created * 1000).toLocaleDateString()}
                      </p>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentHistory;
